import { useFormContext } from 'react-hook-form';
import { TextInput } from '@/components/form/TextInput.tsx';
import ColorInput from '@/components/form/ColorInput.tsx';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import Dot from '@/components/ui/Dot.tsx';
import { colorPresets } from '@/components/form/colorPresets.ts';
import { CostCategoryInputData } from '@/features/dashboard/costCategories/schemas/costCategorySchema.ts';
import { DEFAULT_COST_CATEGORY_COLOR } from '@/features/dashboard/costCategories/types/CostCategory.utils.ts';

const CostCategoryForm = () => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext<CostCategoryInputData>();

  const name = watch('name');
  const color = watch('color') || DEFAULT_COST_CATEGORY_COLOR;

  return (
    <>
      <TextInput
        label="Nazwa"
        required
        placeholder="Np. Wyżywienie, Ubezpieczenie"
        register={register('name')}
        error={errors.name?.message}
      />

      <ColorInput
        label="Kolor"
        required
        fieldPath="color"
        control={control}
        presets={colorPresets}
        fallbackColor={DEFAULT_COST_CATEGORY_COLOR}
        error={errors.color?.message}
        hint="Kolorem malowane jest rozbicie budżetu na kategorie."
      />

      <div className="flex flex-col gap-1.5">
        <InputLabel label="Podgląd" />
        <div className="flex items-center gap-2 text-sm text-base-text">
          <Dot size="xl" hollow style={{ color }} />
          <span>{name?.trim() || 'Nazwa kategorii'}</span>
        </div>
      </div>
    </>
  );
};

export default CostCategoryForm;
